const YMAPS_API_KEY = `e15c0dbf-09e3-4720-801a-0f649780b44b`;

const DURATION = 500; //ms

export {
	YMAPS_API_KEY,
	DURATION,
};
